export enum ActiveFilter{
    DirektProfile='DirektProfile',
}